import React from 'react';

const Twitter = ({ width = 13, height = 12, fill = '#fff', ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 13 12" {...rest}>
    <path
      d="M13 1.8c-.5.2-1 .4-1.5.4.6-.4 1-.9 1.2-1.5-.5.3-1.1.5-1.7.7C10.5.8 9.8.5 9.1.5a2.73 2.73 0 0 0-2.7 2.8c0 .2 0 .4.1.6-1.1-.1-2.1-.3-3.1-.9-1-.5-1.8-1.2-2.4-2a2.77 2.77 0 0 0-.1 2.7c.2.4.5.7.9 1-.4 0-.8-.1-1.2-.4 0 .7.2 1.3.6 1.8.4.5.9.8 1.5 1-.2.1-.5.1-.7.1h-.5c.2.6.5 1 .9 1.4.5.4 1 .5 1.6.6-1 .8-2.1 1.2-3.3 1.2H.1c1.2.8 2.6 1.2 4.1 1.2.9 0 1.8-.2 2.7-.5.8-.3 1.5-.7 2.1-1.3.6-.5 1.1-1.1 1.5-1.8.4-.7.7-1.4 1-2.1.2-.7.3-1.5.3-2.2v-.4c.4-.5.8-.9 1.2-1.5z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);

export default Twitter;
